export default __webpack_public_path__ + "static/pragicts-secops-services-sase-7160f1cfb2fc41502bf19a131836529d.jpg";